import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function dispose(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.dispose('Tab', element, config);
}

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Tab', element, config);
}

// ----------------------------------------------------------------------------

export { dispose, show };
